import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {AdminMobileNavigation} from "../navigation/AdminMobileNavigation";
import React from "react";
import {useTranslation} from "react-i18next";
import {useBoundStore} from "../../Store/store";
import Logo from "../../Assets/images/slogan/connectcaremintgreen.png";
import {ProfileButton} from "../navigation/ProfileButton";
import {FloatingHelpButton} from "../Buttons/FloatingHelpButton";

export const AdminLayout = (props) => {
    const {t} = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const user = useBoundStore(state => state.user)

    const menuitemsFreelance = [
        {title: t('nav.freelancer.shifts'), link: '/freelancer/shifts'},
        {title: t('nav.freelancer.contracts'), link: '/freelancer/contracts'},
        {title: t('nav.freelancer.performance_reports'), link: '/freelancer/performance-report'},
        {title: t('nav.freelancer.invoices'), link: '/freelancer/invoices'},
        {title: t('nav.freelancer.applications'), link: '/freelancer/applications'},
        {title: t('nav.freelancer.planning'), link: '/freelancer/availabilities'},
    ];

    const menuitemsCustomer = [
        {title: t('nav.customer.profile'), link: '/customer/profile'},
        {title: t('nav.customer.shifts'), link: '/customer/shifts'},
        {title: t('nav.customer.collaborations'), link: '/customer/applications'},
        {title: t('nav.customer.contracts'), link: '/customer/contracts'},
        {title: t('nav.customer.payments'), link: '/customer/payments'},
        {title: t('nav.customer.performance_reports'), link: '/customer/performance-reports'},
    ];

    const menuitemsAdmin = [
        {title: t('nav.admin.registrations'), link: '/admin/registrations'},
        {title: t('nav.admin.shifts'), link: '/admin/shifts'},
        {title: t('nav.admin.applications'), link: '/admin/applications'},
        {title: t('nav.admin.customers'), link: '/admin/customers'},
        {title: t('nav.admin.freelancers'), link: '/admin/freelancers'},
        {title: t('nav.admin.invoices'), link: '/admin/invoices'},
        {title: t('nav.admin.statistics'), link: '/admin/statistics'},
        {title: t('nav.admin.bulk_mail'), link: '/admin/bulk-mail'},
    ];

    const isCurrentActive = (value) => {
        return location.pathname.includes(`${value}`);
    }

    const getMenuItems = () => {
        switch (user?.type) {
            case 'freelancer':
                return menuitemsFreelance;
            case 'customer':
                return menuitemsCustomer;
            case 'admin':
                return menuitemsAdmin;
            default:
                return [];
        }
    }

    const getProfileLinks = () => {
        switch (user?.type) {
            case 'admin':
                return [
                    {title: t('profile_menu.logout'), link: '/logout'}
                ]
            case 'customer':
                return [
                    {title: t('profile_menu.profile'), link: '/customer/profile'},
                    {title: '--divider--', link: null},
                    {title: t('profile_menu.logout'), link: '/logout'}
                ]
            case 'freelancer':
                return [
                    {title: t('profile_menu.profile'), link: '/freelancer/profile'},
                    {title: '--divider--', link: null},
                    {title: t('profile_menu.logout'), link: '/logout'}
                ]
        }
    }

    return (
        <div className={'w-full h-full min-h-screen bg-lightGray'}>
            <div className={'hidden xl:block'}>
                <header className="bg-white rounded-full mb-2 py-2 container mx-auto mt-4">
                    <div className="mx-auto px-4 flex items-center justify-between">
                        <div className="text-xl font-bold text-gray-700">
                            <img src={Logo} alt={'Logo for connect care mint green'} className={'max-h-10 mx-auto'}/>
                        </div>

                        <ul className="grid grid-flow-col text-center text-gray-500 space-x-2 rounded-full p-1 border border-gray-300">
                            {
                                getMenuItems().map((item, index) => (
                                    <li key={index}
                                        className={isCurrentActive(item.link) ? 'bg-black text-secondary rounded-full' : ''}>
                                        <a href={item.link} className="flex justify-center py-2 px-2">{item.title}</a>
                                    </li>
                                ))
                            }
                        </ul>

                        <div className="relative">
                            <ProfileButton
                                menuItems={getProfileLinks()}
                            />
                        </div>
                    </div>
                </header>
            </div>
            <div className={'xl:hidden'}>
                <AdminMobileNavigation
                    menuItems={getMenuItems()}
                    isCurrentActive={isCurrentActive}
                    profileLinks={getProfileLinks()}
                />
            </div>

            <main className="container mx-auto py-4">
                <Outlet/>
            </main>

            {user?.type === 'freelancer' && <FloatingHelpButton />}
        </div>
    )
}
